import { GetTripOverviewResponse } from '@orbit/api-types'
import { buildOverviewData } from './buildOverviewData'
import { TripOverviewData } from './types'

/**
 * Normalize the member trip-home endpoint into the bento's `TripOverviewData`.
 * Nothing is gated: membership is settled server-side (ADR 0005), so every
 * section arrives with its detail and every count is the trip-wide total.
 */
export const buildMemberTripOverviewData = (response: GetTripOverviewResponse): TripOverviewData =>
	buildOverviewData(response, {
		// A member's files tile advertises the whole vault, not the slice it previews.
		filesCount: response.sections.files.count,
		payUps: response.sections.expenses.payUps,
	})
